module.exports = __webpack_public_path__ + "media/budapest/bastion_church-86729a98.jpg";